import capitalize from "../utils/capitalize.js";

export default {
  common: {
    invalidInput: (fieldName) => `${capitalize(fieldName)} is invalid.`,
    networkError: "Network error.",
    requestFailed: "Request failed.",
    error: "Something went wrong.",
    lenExceeded: (field, maxLen = 20) =>
      `${capitalize(
        field,
      )} is too long. Maximum length allowed is ${maxLen} characters.`,
    lenTooShort: (field, minLen = 1) =>
      `${capitalize(field)} must be at least ${minLen} characters long.`,
    fieldRequired: (field) => `${capitalize(field)} field is missing.`,
    invalidType: (field, validType = "string") =>
      `Invalid input type: ${field} must be a ${validType.toLowerCase()}.`,
  },
  validator: {
    weakPassword: "Password is too weak.",
  },
};
